import React, { useState } from "react";

import { toast, Button, TextField } from "@telia/teddy";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { isVoucher } from "../../../../../../shared/util";
import WebdealModal from "../../../../checkout/components/molecules/WebdealModal/WebdealModal";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import { addVoucherCode, onVoucherCodeChange } from "../../../state/actions";
import { VOUCHER_ADD } from "../../../state/actionTypes";
import { getVoucherValidationMessage, getVoucherCode } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./RegisterVoucher.less";

interface ReigsterVoucherProps {
    code: string;
    isAddingVoucher: boolean;
    validationMessage?: string;
}

const RegisterVoucher: React.FC<ReigsterVoucherProps> = ({ isAddingVoucher, validationMessage, code }) => {
    const dispatch = useDispatch();
    const [showWebdealModal, setShowWebdealModal] = useState(false);
    const [webdeals, setWebdeals] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleAddVoucher = async () => {
        const response = await dispatch(addVoucherCode(code));
        if (_get(response, "hasMultipleVariants")) {
            setShowWebdealModal(true);
            setWebdeals(_get(response, "webdeals", []));
            return;
        }
        const discountCode = _get(response, "code", "");
        const isSmartDiscount = !_isEmpty(discountCode) && !isVoucher(discountCode);

        if (isSmartDiscount) {
            setIsExpanded(false);
            toast.success("Rabattkoden har blitt lagt til i handlekurven", {
                position: "top-right",
                duration: 6000,
            });
        }
    };

    const handleOnContinue = () => {
        setShowWebdealModal(false);
        toast.success("Produktet har blitt lagt til i handlekurven", {
            position: "top-right",
            duration: 6000,
        });
    };

    if (!isExpanded) {
        return (
            <Button variant="text-underline" className="register-voucher-collapsed" onClick={() => setIsExpanded(true)}>
                Har du gavekort/rabattkode?
            </Button>
        );
    }

    return (
        <div className="register-voucher">
            {showWebdealModal && (
                <WebdealModal onContinue={handleOnContinue} cartItemId={undefined} webdeals={webdeals} />
            )}
            <TextField className="register-voucher__input" errors={validationMessage ? [validationMessage] : undefined}>
                <TextField.Label>{TEXT.REGISTER.INPUT_LABEL}</TextField.Label>
                <TextField.Input
                    value={code || ""}
                    type="text"
                    onChange={(event) => dispatch(onVoucherCodeChange(event.target.value))}
                    data-di-mask
                />
                <TextField.ErrorList />
            </TextField>
            <Button onClick={handleAddVoucher} variant="text-underline" loading={isAddingVoucher}>
                {TEXT.REGISTER.ADD}
            </Button>
        </div>
    );
};

const mapStateToProps = (state: RootState): ReigsterVoucherProps => ({
    isAddingVoucher: LOADING_SELECTORS.isTypeLoading(state, VOUCHER_ADD),
    validationMessage: getVoucherValidationMessage(state),
    code: getVoucherCode(state),
});

export default connect(mapStateToProps)(RegisterVoucher);
